import { MODAL_CLOSE_VALUE, RECURRING_MODEL_CHECK, SET_RECURRING_MODEL_CHECK, SET_SELECTED_BATCH_ID } from "../../../app/redux/constants/index";
import {
  HEADER_LOGO,
  HEADER_LOGO_IN_BASE,
  HIDE_PAYMENT_BUTTON,
  PAYALLNOWVALUE,
  PAYALLVALUE,
  PAY_NOW,
  SHOW_BATCH_TABLE,
} from "../constants/index";

const initial_state = {
  headerLogo: null,
  paynowValue: null,
  ShowTable: null,
  payNowValueData: null,
  RecurringModelCheck: false,
  hidePaymentButton: false,
  SetRecurringCheck: 'hide',
  selectedBatch_Id: null,
  getValueForModal: false,
};

const Projects = (state = initial_state, action) => {
  switch (action.type) {
    case HEADER_LOGO:
      return {
        ...state,
        headerLogo: action.payload,
      };
    case RECURRING_MODEL_CHECK:
      return {
        ...state,
        RecurringModelCheck: action.payload
      }
    case SET_RECURRING_MODEL_CHECK:
      return {
        ...state,
        SetRecurringCheck: action.payload
      }
    case SET_SELECTED_BATCH_ID:
      return {
        ...state,
        selectedBatch_Id: action.payload
      }
    case MODAL_CLOSE_VALUE:
      return {
        ...state,
        getValueForModal: action.payload
      }
    case PAY_NOW:
      return {
        ...state,
        paynowValue: action.payload,
      };
    case SHOW_BATCH_TABLE:
      return {
        ...state,
        ShowTable: action.payload,
      };
    case HEADER_LOGO_IN_BASE:
      return {
        ...state,
        convertImageHeader: action.payload,
      };
    case HIDE_PAYMENT_BUTTON:
      return {
        ...state,
        hidePaymentButton: action.payload
      }
    case PAYALLVALUE:
      return {
        ...state,
        ShowPayALlValue: action.payload,
      };
    case PAYALLNOWVALUE: {
      return {
        ...state,
        payNowValueData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default Projects;